module.exports = __webpack_public_path__ + "img/Other.e5485d46.png";